<template>
    <div class="membersAreaWrap">
        <div class="memberAreaHead">
            <i></i>
            <i></i>
            <span>会员专区</span>
        </div>
        <div class="membersAreaTop">
            <ul>
                <li v-for = "( item, index ) in dataArr" :key = 'index'>
                    <img :src="item.picUrl" alt="">
                    <div>
                        <h4>{{item.name}}</h4>
                        <s>原价{{(item.price/100).toFixed(2)}}元</s>
                        <p>尊享价<span>{{(item.salerPrice/100).toFixed(2)}}</span>元</p>
                        <div>
                            <button @click="goShopDetail(item.sn)">立即购买</button>
                        </div>
                        <span>省{{((item.price - item.salerPrice)/100).toFixed(2)}}元</span>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import Footer from '@/components/footer'
export default {
    data() {
        return {
            token: '',
            dataArr: []
        }
    },
    components: {
        'v-footer': Footer
    },
    mounted() {
        this.token = this.$route.query.token
        this.init()
    },
    methods: {
        //初始数据列表
        init() {
            this.$axios({
                method: 'post',
                url: this.GLOBAL.pro + '/shop/sditeminfo/getItemInfoList',
                headers: {
                    "Content-Type": "application/json", //设置请求头请求格式为JSON
                },
                data: {
                }
            }).then(res => {
                this.dataArr = res.data.result
            }).catch(e => {
                console.log(e);
            });
        },
        //跳转商品详情页
        goShopDetail(sn) {
            this.$router.push('/shopDetail?itemSn=' + sn+"&token="+this.token)
        }
    }
}
</script>
<style lang="sass" scoped>
.membersAreaWrap
    width: 100%;
    height: 100vh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    .memberAreaHead
        width: 100%;
        height: 0.5rem;
        position: relative;
        i
            width: 1.7rem;
            height: 0.03rem;
            background: #797979;
            display: block;

        i:nth-child(1)
            position: absolute;
            left: 50%;
            top: 43%;
            transform: translate(-50%, -50%);
        i:nth-child(2)
            position: absolute;
            left: 50%;
            top: 57%;
            transform: translate(-50%, -50%);
        span
            width: 1.1rem;
            background: #fff;
            height: 0.5rem;
            display: block;
            text-align: center;
            line-height: 0.5rem;
            position: absolute;
            font-size: 0.14rem;
            color: #E1C7A3;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
    .membersAreaTop
        flex: 1;
        width: 100%;
        overflow: auto;
        ul
            width: 100%;
            height: auto;
            padding: 0 0.1rem;
            display: flex;
            flex-wrap: wrap;
            li
                width: 50%;
                padding: 0 0.03rem;
                height: auto;
                margin-top: 0.1rem;
                img
                    width: 100%;
                    height: 1.68rem;
                    border: 1px solid #eee;
                    border-bottom: 0;
                    display: block;
                    border-top-left-radius: 0.1rem;
                    border-top-right-radius: 0.1rem;
                >div
                    width: 100%;
                    height: auto;
                    position: relative;
                    background: #F8F8F7;
                    border-bottom-left-radius: 0.1rem;
                    border-bottom-right-radius: 0.1rem;
                    padding: 0 0.1rem;
                    >h4
                        font-size: 0.14rem;
                        padding-top: 0.07rem;
                        color: #565656;
                        font-weight: bolder;
                        width: 100%;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        white-space: nowrap;
                    >s
                       font-size: 0.13rem;
                       padding-top: 0.04rem;
                       color: #828282;
                       display: block;
                    >p
                        padding-top: 0.04rem;
                        color: #333;
                        font-size: 0.13rem;
                        >span
                            color: #FC5653;
                            font-size: 0.15rem;
                            font-weight: bolder;
                    >div
                        height: 0.35rem;
                        >button
                            width: 100%;
                            height: 0.25rem;
                            border: 0;
                            outline: 0;
                            background: #FC5653;
                            display: block;
                            border-radius: 0.2rem;
                            color: #fff;
                            margin-top: 0.1rem;
                    >span
                        position: absolute;
                        right: 0.1rem;
                        top: 45%;
                        font-size: 0.13rem;
                        display: block;
                        padding: 0.01rem 0.05rem;
                        color: #B68953;
                        background: #EDD5A0;
                        border-top-left-radius: 0.1rem;
                        border-bottom-right-radius: 0.1rem;

</style>



// WEBPACK FOOTER //
// src/page/membersArea.vue